const { parsePix } = require('pix-utils');
const { errors } = require('@transfeeradev/api-enums');
const success = require('./success');
const ValidationError = require('./errors/ValidationError');

class Transfer {
  constructor(data) {
    this._transfer = { ...data.transfer };
  }

  validate() {
    if (this._transfer.emv) {
      const parsedEMV = parsePix(this._transfer.emv);

      if (parsedEMV.error) {
        return new ValidationError(errors.ptBr.tra.INVALID_EMV);
      }
    }

    return success;
  }
}

module.exports = Transfer;
